import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

export default function Belem() {
  return (
    <section id="guincho-belem" className="bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24 grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <p className="text-[#50CF08] uppercase tracking-widest text-sm font-semibold">Capital paraense</p>
          <h2 className="font-bebas text-4xl md:text-6xl uppercase tracking-tight text-[#FEFB0E] mt-2">
            Guincho em Belém
          </h2>
          <div className="mt-6 space-y-4 text-base md:text-lg text-neutral-400 leading-relaxed">
            <p>
              Se o seu carro, moto ou utilitário parou em Belém, a Brasil Transportes atende você com
              remoção e transporte de veículos em toda a capital. Trabalhamos com reboque Asa Delta
              para remoções ágeis de veículos leves e com plataforma para situações em que o veículo
              precisa ser transportado integralmente, sem rodar.
            </p>
            <p>
              O tipo de equipamento é definido conforme o veículo e a situação: pane, acidente,
              revisão ou simples deslocamento entre endereços. Além do reboque, também realizamos
              recarga de bateria e troca de pneu em emergências dentro da cidade.
            </p>
            <p>
              Para agilizar, envie pelo WhatsApp sua localização e o modelo do veículo. Assim
              conseguimos indicar o equipamento certo e chegar até você com mais rapidez.
            </p>
          </div>
          <a
            href={waLink("Olá! Preciso de guincho em Belém. Minha localização é ______ e o veículo é ______.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="belem-whatsapp-btn"
            className="mt-8 inline-flex items-center gap-3 bg-[#50CF08] hover:bg-[#42B006] text-white font-extrabold uppercase text-lg px-8 py-4 rounded-md transition-all duration-300 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#FEFB0E]"
          >
            <MessageCircle className="w-6 h-6" />
            Solicitar atendimento em Belém
          </a>
        </div>
        <div className="relative">
          <div className="absolute -inset-2 border border-[#FEFB0E]/40 rounded-md translate-x-4 translate-y-4" aria-hidden="true" />
          <img
            src="/images/guincho-asa-delta-dia.jpeg"
            alt="Guincho Asa Delta da Brasil Transportes removendo veículo em avenida de Belém"
            loading="lazy"
            className="relative rounded-md w-full max-h-[560px] object-cover object-center"
          />
        </div>
      </div>
    </section>
  );
}
